import { Subscription } from '@pepper/ui'
import {
  CMP_SALES_CONTACT_URL,
  BOOK_A_DEMO_URL,
} from 'utils/constants/website_urls'

export const getCmpBannerText = (subscription: Subscription | null) => {
  if (subscription === null) {
    return {
      bannerStateDescriptor: 'UPGRADE TO PREMIUM',
      title: 'Start your free trial',
      description:
        'Leverage the AI-powered platform to strategize, create, distribute, and measure performance of your content and prove your content marketing ROI.',
      primaryBtnDescription: 'Book A Demo',
      secondaryBtnDescription: 'View Pricing',
      primaryBtnLink: BOOK_A_DEMO_URL,
    }
  } else {
    switch (subscription?.trialStatus) {
      case 'active':
        return {
          bannerStateDescriptor: 'YOUR TRIAL PLAN IS ACTIVE',
          title: 'Request Trial Extension',
          description:
            "Your free trial is amazing, isn't it? And it's only the beginning! Get in touch to unlock the full potential of the platform.",
          primaryBtnDescription: 'Get in Touch',
          secondaryBtnDescription: 'View Pricing',
          primaryBtnLink: CMP_SALES_CONTACT_URL,
        }
      case 'expired':
        return {
          bannerStateDescriptor: 'TRIAL EXPIRED',
          title: 'Upgrade & Unlock',
          description:
            "Achieve your content marketing ROI with Pepper's AI-powered platform and expert network.",
          primaryBtnDescription: 'Contact Sales',
          primaryBtnLink: CMP_SALES_CONTACT_URL,
        }
      default:
        return {
          bannerStateDescriptor: 'UPGRADE TO PREMIUM',
          title: 'Start your free trial',
          description:
            'Leverage the AI-powered platform to strategize, create, distribute, and measure performance of your content and prove your content marketing ROI.',
          primaryBtnDescription: 'Book a demo',
          secondaryBtnDescription: 'View Pricing',
          primaryBtnLink: BOOK_A_DEMO_URL,
        }
    }
  }
}
